import { useContext } from 'react';
import { UploadStateContext } from '../context';
export const useShowRemove = (file) => {
    const { showRemove, readOnly } = useContext(UploadStateContext);
    if (readOnly)
        return false;
    if (typeof showRemove === 'function')
        return showRemove(file);
    return showRemove;
};
